import { http, HttpResponse } from 'msw';

const handlers = [
  http.get('*/:userId/ui-preferences', () =>
    HttpResponse.json(
      {
        useDarkTheme: false,
        disableAnimation: false,
      },
      { status: 200 }
    )
  ),
];

export default handlers;
